// subscription-toggle.js
document.addEventListener("DOMContentLoaded", function () {
  const atcButton = document.querySelector('[id^="ProductSubmitButton"]');

  if (!atcButton) {
    console.warn("❌ ATC button not found");
    return;
  }

  function updatePriceLabel() {
    const selectedInput = document.querySelector(".skio-group-input:checked");

    if (!selectedInput) {
      console.warn("❌ No selected skio-group-input found");
      return;
    }

    const container = selectedInput.closest(".skio-group-container");
    if (!container) {
      console.warn("❌ No skio-group-container found for selected input");
      return;
    }

    const priceElement = container.querySelector("[skio-subscription-price]") || container.querySelector("[skio-onetime-price]");
    const priceText = priceElement?.innerText?.trim();

    if (priceText) {
      console.log("✅ Updating ATC button to:", priceText);
      atcButton.innerText = `ADD TO CART - ${priceText}`;
    } else {
      console.warn("⚠️ No price found in skio container");
    }
  }

  function bindListeners() {
    const inputs = document.querySelectorAll(".skio-group-input");
    if (!inputs.length) {
      console.log("⏳ Waiting for SKIO inputs...");
      setTimeout(bindListeners, 300);
      return;
    }

    inputs.forEach(input => {
      input.addEventListener("change", updatePriceLabel);
    });

    console.log("✅ Listeners bound to .skio-group-input");
    updatePriceLabel();
  }

  const observer = new MutationObserver(() => {
    if (document.querySelectorAll(".skio-group-input").length) {
      bindListeners();
      observer.disconnect();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });

  bindListeners();
});
